export const INVESTOR_BANKS_LIST_SUCCESS = "INVESTOR_BANKS_LIST_SUCCESS";
export const INVESTOR_BANKS_LIST = "INVESTOR_BANKS_LIST";

export const BANKS_LIST_SUCCESS = "BANKS_LIST_SUCCESS";
export const BANKS_LIST = "BANKS_LIST";

export const BSE_SUBMIT_GEN_OTP_SUCCESS = "BSE_SUBMIT_GEN_OTP_SUCCESS";
export const BSE_SUBMIT_GEN_OTP = "BSE_SUBMIT_GEN_OTP";

export const BSE_SUBMIT_VALIDATE_OTP_SUCCESS = "BSE_SUBMIT_VALIDATE_OTP_SUCCESS";
export const BSE_SUBMIT_VALIDATE_OTP = "BSE_SUBMIT_VALIDATE_OTP";

export const BSE_RESEND_OTP_SUCCESS = "BSE_RESENT_OTP_SUCCESS";
export const BSE_RESEND_OTP = "BSE_RESENT_OTP";